import { render, staticRenderFns } from "./Appeal.vue?vue&type=template&id=6246ac31&scoped=true"
import script from "./Appeal.vue?vue&type=script&lang=js"
export * from "./Appeal.vue?vue&type=script&lang=js"
import style0 from "./Appeal.vue?vue&type=style&index=0&id=6246ac31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6246ac31",
  null
  
)

export default component.exports